import {Paper as MuiPaper, Box} from '@mui/material';
import {styled} from '@mui/system';


import {Styles} from '../Styles/Styles.js';


const Paper = styled(MuiPaper)(({theme}) => (
  Styles.paper
));


const section = styled(Box)(({theme}) => (
  Styles.section
));


const sectionTitle = styled('div')(({theme}) => (
  Styles.sectionTitle
));


export default Paper;
export {section, sectionTitle};
